// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProtocolData } from './protocol-data';
import {
    ProtocolDataFromJSON,
    ProtocolDataFromJSONTyped,
    ProtocolDataToJSON,
    ProtocolDataToJSONTyped,
} from './protocol-data';

/**
 * 
 * @export
 * @interface CreateProtocolRequest
 */
export interface CreateProtocolRequest {
    /**
     * 
     * @type {ProtocolData}
     * @memberof CreateProtocolRequest
     */
    data: ProtocolData;
}

/**
 * Check if a given object implements the CreateProtocolRequest interface.
 */
export function instanceOfCreateProtocolRequest(value: object): value is CreateProtocolRequest {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateProtocolRequestFromJSON(json: any): CreateProtocolRequest {
    return CreateProtocolRequestFromJSONTyped(json, false);
}

export function CreateProtocolRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateProtocolRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ProtocolDataFromJSON(json['data']),
    };
}

export function CreateProtocolRequestToJSON(json: any): CreateProtocolRequest {
    return CreateProtocolRequestToJSONTyped(json, false);
}

export function CreateProtocolRequestToJSONTyped(value?: CreateProtocolRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ProtocolDataToJSON(value['data']),
    };
}
